/**
 * 개인정보 고지 초안 (PRD2 T-0.10, A7).
 * 법무 검토 전의 화면 문구다.
 */

export const PRIVACY_ITEMS = [
  { id: "email", label: "이메일", use: "로그인, 초대, 이메일 코드 열람을 구분합니다." },
  { id: "ipHash", label: "IP 해시", use: "같은 열람을 셉니다. 원문은 저장하지 않습니다." },
  { id: "viewer", label: "열람자 식별", use: "인증된 열람의 이름, 횟수, 마지막 시각입니다." },
  { id: "avatar", label: "아바타", use: "프로필 사진입니다. 지금은 이 브라우저에만 둡니다." },
] as const;

export const PRIVACY_NOTICE =
  "이메일, 열람 기록, 프로필 사진을 서비스 운영에 씁니다. 접속 주소의 원문은 저장하지 않고, 비밀번호는 받지 않습니다.";

export const PRIVACY_REVIEW = "법무 검토 전 초안입니다.";
